module.exports = __webpack_public_path__ + "img/avatar.cfb8adcb.svg";